/** @typedef	{import('../../../../shared/SubscriptionCheckout/SubscriptionPlans/Tier').default} Tier */

import { translate } from '../../../Internationalization';

/** @type {Tier[]} */
export default [
	{
		description: translate('subscription.plans.starter.description'),
		features: [
			translate('subscription.plans.starter.features.1'),
			translate('subscription.plans.starter.features.2'),
			translate('subscription.plans.starter.features.3'),
			translate('subscription.plans.starter.features.4'),
			translate('subscription.plans.external_cta'),
		],
		pricePerMonth: 495,
		title: 'starter',
	},
	{
		description: translate('subscription.plans.standard.description'),
		features: [
			translate('subscription.plans.standard.features.1'),
			translate('subscription.plans.standard.features.2'),
			[
				translate('subscription.plans.standard.features.3'),
				translate('subscription.plans.standard.features.4'),
			],
			translate('subscription.plans.standard.features.5'),
			translate('subscription.plans.standard.features.6'),
			translate('subscription.plans.standard.features.7'),
			translate('subscription.plans.external_cta'),
		],
		popular: true,
		pricePerMonth: 995,
		title: 'standard',
	},
	{
		description: translate('subscription.plans.professional.description'),
		features: [
			translate('subscription.plans.professional.features.1'),
			translate('subscription.plans.professional.features.2'),
			translate('subscription.plans.professional.features.3'),
			translate('subscription.plans.professional.features.4'),
			translate('subscription.plans.professional.features.5'),
			translate('subscription.plans.external_cta'),
		],
		pricePerMonth: 1995,
		title: 'professional',
	},
	{
		description: translate('subscription.plans.enterprise.description'),
		features: [
			translate('subscription.plans.enterprise.features.1'),
			translate('subscription.plans.enterprise.features.2'),
			translate('subscription.plans.enterprise.features.3'),
			translate('subscription.plans.enterprise.features.4'),
			translate('subscription.plans.enterprise.features.5'),
			translate('subscription.plans.external_cta'),
		],
		pricePerMonth: 0,
		title: 'enterprise',
	},
];
